import http from '~/common/http'
export default {
    // 部门|成员 目标
    getGoalCount(params, action) {
        return http.get('/api/goal-count/' + action, {
            params: params
        });
    },
    
    // 保存目标
    saveGoal(params) {
        return http.post('/api/goal-count/save-goal', params)
    },
}


// WEBPACK FOOTER //
// ./src/services/UserCount.js